import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('a-form', {
    staticClass: "ant-advanced-search-form",
    attrs: {
      "layout": "inline",
      "data-sign": "logistics_agent_abnormal_search_form",
      "from": _vm.searchData
    }
  }, [_c('a-form-item', [_c('a-input-group', {
    staticClass: "form-item-inline form-item-keyword-box",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false
    },
    model: {
      value: _vm.searchData.search_keyword,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "search_keyword", $$v);
      },
      expression: "searchData.search_keyword"
    }
  }, [_c('a-select-option', {
    attrs: {
      "data-permission": "logistics_agent_abnormal_search_code",
      "id": "logistics_agent_abnormal_search_code",
      "value": _vm.$enum.internationalDelivery.LogisticsAgentKeyWord.LOGISTICS_AGENT_CODE
    }
  }, [_vm._v(_vm._s(_vm.t('送仓单号')))]), _c('a-select-option', {
    attrs: {
      "data-permission": "logistics_agent_abnormal_search_reference",
      "id": "logistics_agent_abnormal_search_reference",
      "value": _vm.$enum.internationalDelivery.LogisticsAgentKeyWord.REF_CODE
    }
  }, [_vm._v(_vm._s(_vm.t('参考号')))])], 1), _c('a-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-analyse-name": $t("\u53CC\u51FB\u53EF\u6279\u91CF\u67E5\u8BE2"),
      "maxLength": 100,
      "allowClear": "",
      "placeholder": _vm.t('双击可批量查询')
    },
    on: {
      "dblclick": _vm.handleDblClick,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.handleSearch($event);
      }
    },
    model: {
      value: _vm.docValue,
      callback: function ($$v) {
        _vm.docValue = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "docValue"
    }
  })], 1)], 1), _c('a-form-item', [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u7269\u6D41\u4EA7\u54C1"),
      "allowClear": "",
      "show-search": "",
      "show-tip": "",
      "data-permission": "logistics_agent_abnormal_search_logistics",
      "id": "logistics_agent_abnormal_search_logistics",
      "placeholder": _vm.t('物流产品')
    },
    model: {
      value: _vm.searchData.sm_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "sm_code", $$v);
      },
      expression: "searchData.sm_code"
    }
  }, _vm._l(_vm.domesticLogisticsProductList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.sm_code
      }
    }, [_vm._v(" " + _vm._s(item.sm_code_name) + " ")]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u4E2D\u8F6C\u4ED3"),
      "allowClear": "",
      "show-tip": "",
      "show-search": "",
      "data-permission": "logistics_agent_abnormal_search_transit",
      "id": "logistics_agent_abnormal_search_transit",
      "placeholder": _vm.t('中转仓')
    },
    model: {
      value: _vm.searchData.wp_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "wp_code", $$v);
      },
      expression: "searchData.wp_code"
    }
  }, _vm._l(_vm.domesticTransitionWarehouseGroup, function (item) {
    return _c('a-select-opt-group', {
      key: item.country_code,
      attrs: {
        "label": item.country
      }
    }, _vm._l(item.transition_warehouse_list, function (warehouse) {
      return _c('a-select-option', {
        key: warehouse.wp_code,
        attrs: {
          "value": warehouse.wp_code
        }
      }, [_vm._v(_vm._s(warehouse.warehouse_name_cn))]);
    }), 1);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u76EE\u7684\u4ED3"),
      "allowClear": "",
      "show-tip": "",
      "show-search": "",
      "data-permission": "logistics_agent_abnormal_search_warehouse",
      "id": "logistics_agent_abnormal_search_warehouse",
      "placeholder": _vm.t('目的仓')
    },
    model: {
      value: _vm.searchData.warehouse_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "warehouse_type", $$v);
      },
      expression: "searchData.warehouse_type"
    }
  }, _vm._l(_vm.warehouseTypeEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]);
  }), 1)], 1)], 1), _c('a-form-item', [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false
    },
    model: {
      value: _vm.searchData.rectime_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "rectime_type", $$v);
      },
      expression: "searchData.rectime_type"
    }
  }, [_c('a-select-option', {
    attrs: {
      "data-permission": "logistics_agent_abnormal_search_creat",
      "id": "logistics_agent_abnormal_search_creat",
      "value": _vm.$enum.internationalDelivery.LogisticsAgentTimeType.CREATE_TIME
    }
  }, [_vm._v(_vm._s(_vm.t('创建时间')))]), _c('a-select-option', {
    attrs: {
      "data-permission": "logistics_agent_abnormal_search_update",
      "id": "logistics_agent_abnormal_search_update",
      "value": _vm.$enum.internationalDelivery.LogisticsAgentTimeType.UPDATE_TIME
    }
  }, [_vm._v(_vm._s(_vm.t('更新时间')))])], 1), _c('my-range-picker', {
    attrs: {
      "placeholder": [_vm.t('开始'), _vm.t('结束')],
      "format": "YYYY/MM/DD"
    },
    model: {
      value: _vm.datetimeDefaultValue,
      callback: function ($$v) {
        _vm.datetimeDefaultValue = $$v;
      },
      expression: "datetimeDefaultValue"
    }
  })], 1)], 1), _c('a-form-item', [_c('a-button', {
    attrs: {
      "type": "primary",
      "ghost": "",
      "data-permission": "logistics_agent_abnormal_search",
      "id": "logistics_agent_abnormal_search",
      "data-sign": "logistics_agent_abnormal_search",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(_vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "margin-left",
    attrs: {
      "data-permission": "logistics_agent_abnormal_reset",
      "id": "logistics_agent_abnormal_reset",
      "data-sign": "logistics_agent_abnormal_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleClear
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "tableContent"
  }, [_c('div', {
    staticClass: "listTool mt-10"
  }, [_c('div', {
    staticClass: "fl"
  }, [_vm._v(" " + _vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', '：')) + " " + _vm._s(_vm.selectedList.length) + " "), _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'logistics_agent_discard',
      expression: "'logistics_agent_discard'"
    }],
    attrs: {
      "data-permission": "logistics_agent_abnormal_discard_bulk",
      "id": "logistics_agent_abnormal_discard_bulk",
      "data-sign": "logistics_agent_abnormal_discard_bulk",
      "fbu-analyse-name": $t("\u5E9F\u5F03")
    },
    on: {
      "click": _vm.handleSelectedAbandon
    }
  }, [_vm._v(_vm._s(_vm.t('废弃')))])], 1)]), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    staticClass: "box min-ptext",
    attrs: {
      "bordered": "",
      "is-filter-box": "",
      "fixed-header": "",
      "data-sign": "logistics_agent_abnormal_list",
      "columns": _vm.columns,
      "useMouseTool": "",
      "name": "logisticsAgentAbnormalList",
      "data-source": _vm.data,
      "row-key": "gc_fba_order_code",
      "row-selection": _vm.rowSelection
    },
    scopedSlots: _vm._u([{
      key: "code",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('div', {
          staticClass: "code-box"
        }, [_c('div', {
          staticClass: "code-label"
        }, [_vm._v(" " + _vm._s(_vm.t('送仓单号：')) + " ")]), _c('div', {
          staticClass: "code-content"
        }, [_c('router-link', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.gc_fba_order_code,
            expression: "record.gc_fba_order_code"
          }],
          attrs: {
            "to": {
              name: 'LogisticsAgentDetailPage',
              query: {
                code: record.gc_fba_order_code,
                order_type: record.fba_order_type,
                name: _vm.$route.name
              }
            }
          }
        }, [_vm._v(_vm._s(record.gc_fba_order_code))])], 1)]), record.refer_code ? _c('div', {
          staticClass: "code-box"
        }, [_c('div', {
          staticClass: "code-label"
        }, [_vm._v(" " + _vm._s(_vm.t('参考号：')) + " ")]), _c('div', {
          staticClass: "code-content"
        }, [_c('span', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.refer_code,
            expression: "record.refer_code"
          }]
        }, [_vm._v(_vm._s(record.refer_code))])])]) : _vm._e()]);
      }
    }, {
      key: "country_code",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [record.country_code ? _c('span', [_vm._v(_vm._s(_vm._f("filterEmpty")(record.country_code)) + "[" + _vm._s(_vm._f("filterEmpty")(record.country_name)) + "]")]) : _c('span', [_vm._v(_vm._s(_vm._f("filterEmpty")('')))])]);
      }
    }, {
      key: "sm_code",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [record.sm_code_name ? _c('p', [_c('span', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.sm_code_name,
            expression: "record.sm_code_name"
          }]
        }, [_vm._v(_vm._s(record.sm_code_name))])]) : _vm._e(), record.sm_code ? _c('p', {
          staticStyle: {
            "color": "#bfbfbf"
          }
        }, [_c('span', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.sm_code,
            expression: "record.sm_code"
          }]
        }, [_vm._v(_vm._s(record.sm_code))])]) : _vm._e()]);
      }
    }, {
      key: "exception_surface_info",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('a', {
          attrs: {
            "href": "javascript:",
            "data-sign": "logistics_agent_abnormal_view",
            "data-permission": "logistics_agent_abnormal_view",
            "id": "logistics_agent_abnormal_view",
            "fbu-analyse-name": $t("\u70B9\u51FB\u67E5\u770B")
          },
          on: {
            "click": function ($event) {
              return _vm.handleViewReason(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('点击查看')))])]);
      }
    }, {
      key: "time",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [record.created_at ? _c('p', [_vm._v(_vm._s(_vm.t('创建')) + _vm._s(_vm.t('common', '：')) + _vm._s(record.created_at))]) : _vm._e(), record.updated_at ? _c('p', [_vm._v(_vm._s(_vm.t('更新')) + _vm._s(_vm.t('common', '：')) + _vm._s(record.updated_at))]) : _vm._e()]);
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {
          staticClass: "operation-btns"
        }, [_c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'logistics_agent_edit',
            expression: "'logistics_agent_edit'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-sign": "logistics_agent_abnormal_edit",
            "data-permission": "logistics_agent_abnormal_edit",
            "id": "logistics_agent_abnormal_edit",
            "fbu-analyse-name": $t("\u7F16\u8F91")
          },
          on: {
            "click": function ($event) {
              return _vm.handleEdit(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('编辑')))]), _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'logistics_agent_abnormal_submit',
            expression: "'logistics_agent_abnormal_submit'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-sign": "logistics_agent_abnormal_submit",
            "data-permission": "logistics_agent_abnormal_submit",
            "id": "logistics_agent_abnormal_submit",
            "fbu-analyse-name": $t("\u91CD\u65B0\u63D0\u4EA4")
          },
          on: {
            "click": function ($event) {
              return _vm.handleSubmit(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('重新提交')))]), record.status !== _vm.$enum.internationalDelivery.LogisticsAgentStatus.DISCARD ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'logistics_agent_discard',
            expression: "'logistics_agent_discard'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-sign": "logistics_agent_abnormal_discard",
            "data-permission": "logistics_agent_abnormal_discard",
            "id": "logistics_agent_abnormal_discard",
            "fbu-analyse-name": $t("\u5E9F\u5F03")
          },
          on: {
            "click": function ($event) {
              return _vm.handleAbandon(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('废弃')))]) : _vm._e()]);
      }
    }])
  })], 1), _c('div', {
    staticClass: "pagination-box"
  }, [_c('my-pagination', {
    attrs: {
      "total": _vm.total,
      "isFixed": "",
      "name": "logisticsAgentAbnormalList",
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    },
    model: {
      value: _vm.searchData.page_index,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "page_index", $$v);
      },
      expression: "searchData.page_index"
    }
  })], 1)], 1), _c('bulk-search-modal', {
    ref: "bulkSearchModal",
    attrs: {
      "max-number": 30
    },
    on: {
      "bulkSearch": _vm.handleBulkFeedback
    }
  }), _c('detail-modal', {
    ref: "detailModalRef",
    attrs: {
      "data": _vm.editData
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };